module.exports = __webpack_public_path__ + "img/true_label_2.3bbf5c90.jpg";